const listeners = new Set();

export const subscribeProductEvents = (listener) => {
  if (typeof listener !== 'function') return () => {};
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const notifyProductEvent = (payload) => {
  listeners.forEach((listener) => listener(payload));
};

export const invalidateProducts = (branchId, meta = {}) => {
  notifyProductEvent({
    type: 'products.invalidated',
    branchId: branchId ?? null,
    ...meta,
  });
};
